<div class="page" >
  <div class="top-link-container" *ngIf="alternateDisplayForMarkets"><a class="top-link-continue" (click)="click(false)">{{ 'popin.btn.notagree' | translate }}</a></div>

  <div class="top-space"></div>

  <img class="icon" src="../../assets/{{logo}}" *ngIf="logo.length"/>

  <h3>{{ 'popin.title' | translate}}</h3>

  <div class="spacing-top-3">
    {{ 'popin.text' | translate}}
    <a (click)="click('openAll')" href="javascript:void(0)" >{{ 'popin.seeall' | translate}}</a>
    {{ 'popin.text2' | translate}}
    <a [href]="policyUrl" target="_blank" >{{ 'popin.knowmore.link' | translate}}</a>
    {{ 'popin.text3' | translate}}
  </div>
  <br/>

  <div class="spacing-top-n3">
    {{ 'popin.paragraph2' | translate}}
  </div>
  <br/>


  <div class="spacing-top-n3">
    {{  'popin.change.text1' | translate}}
    <a (click)="click('')" >{{ 'popin.change.text2' | translate}}</a>
    {{  'popin.change.text3' | translate}}
    {{ 'popin.knowmore.policy' | translate}}<a [href]="cookiePolicyUrl" target="_blank" >
    {{ 'popin.knowmore.policy.url' | translate}}</a>
    {{ 'popin.change.text4' | translate}}
  </div>
  <br/>




  <div style="height: 150px;"></div>
</div>

<div class="fixed-bottom">
  <p class="text-center spacing-top-3">
    <button class="custom btn btn-main no-select {{alternateDisplayForMarkets ? 'btn-xl' : '' }}" (click)="click(true)">
      <a>{{ 'popin.btn.agree' | translate }}</a>
    </button>
  </p>
  <p class="text-center spacing-top-2">
    <button class="custom btn no-select {{alternateDisplayForMarkets ? 'btn-xl' : '' }}" (click)="click('')">
      <a>{{ 'popin.btn.customise' | translate }}</a>
    </button>
  </p>
  <p class="text-center spacing-top-3" *ngIf="!alternateDisplayForMarkets">
    <button class="custom btn no-select" (click)="click(false)"><a>{{ 'popin.btn.notagree' | translate }}</a></button>
  </p>
</div>
